import * as React from "react";
const SvgEllipse = props => <svg xmlns="http://www.w3.org/2000/svg" width={122} height={87} fill="transparent" viewBox="0 0 122 87" {...props}><ellipse cx={61} cy={43.5} rx={60} ry={42.5} /></svg>;
export default SvgEllipse;